import { render, staticRenderFns } from "./AulasLancadas.vue?vue&type=template&id=6daffb15&scoped=true"
import script from "./AulasLancadas.vue?vue&type=script&lang=js"
export * from "./AulasLancadas.vue?vue&type=script&lang=js"
import style0 from "./AulasLancadas.vue?vue&type=style&index=0&id=6daffb15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daffb15",
  null
  
)

export default component.exports